import DSBox from '../../../design-system/DSBox';
import { useDashboard } from '../hooks/useDashboard';
import DSGradientViewPaper from '../../../design-system/Paper/DSGradientViewPaper';
import { ReactComponent as KlydoIcon } from '../../../design-system/Icons/KlydoIcon.svg';
import { useTheme } from '@mui/material';
import { DSTypography } from '../../../design-system/Typography';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import CalendarEventWidget from './CalendarEventWidget';
import KlydoCarousel from './KlydoCarousel';
import AnalyticsSection from './AnalyticsSection';

const Dashboard = () => {
  const { topKlydos, isTopKlydosLoading } = useDashboard();
  const { spacing, palette } = useTheme();

  const TopKlydoseEmptyStates = () => {
    if (isTopKlydosLoading) {
      return <DSCircularProgress sx={{ alignSelf: 'center' }} />;
    }
    if (!isTopKlydosLoading && !topKlydos?.length) {
      return (
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            gap: spacing(2),
          }}
        >
          <KlydoIcon />
          <DSTypography
            sx={{
              color: palette.action.disabled,
              fontFamily: 'Gilroy-Medium',
              fontSize: spacing(2),
              textAlign: 'center',
              width: '80%',
            }}
          >
            You don’t have any Approved Klydos Yet
          </DSTypography>
        </DSBox>
      );
    }
    return null;
  };

  return (
    <DSBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        marginY: { xs: spacing(0), xl: spacing(3) },
        overflow: 'hidden',
      }}
    >
      <DSBox
        sx={{
          flexGrow: 1,
          display: 'flex',
          gap: spacing(4),
          flexDirection: { xxs: 'column-reverse', sm: 'row' },
        }}
      >
        <DSGradientViewPaper
          sx={{
            width: { xxs: '100%', sm: '60%' },
            flexDirection: 'column',
            flexGrow: 1,
            paddingY: { xxs: 2, xs: spacing(3) },
            paddingX: { xxs: 2, xs: spacing(3) },
            gap: spacing(1),
            minHeight: '400px',
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          <AnalyticsSection />
        </DSGradientViewPaper>
        <DSBox
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: spacing(3),
            width: { xxs: '100%', sm: '40%' },
            minWidth: 0,
          }}
        >
          <CalendarEventWidget />

          <DSGradientViewPaper
            sx={{
              flexDirection: 'column',
              padding: spacing(1),
              gap: spacing(1),
            }}
          >
            <DSTypography
              variant="h6"
              sx={{ marginLeft: spacing(3), marginTop: spacing(2) }}
            >
              Top Klydos
            </DSTypography>
            <DSBox
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                overflow: 'hidden',
              }}
            >
              <TopKlydoseEmptyStates />
              {topKlydos && topKlydos.length > 0 && (
                <KlydoCarousel klydos={topKlydos} />
              )}
            </DSBox>
          </DSGradientViewPaper>
        </DSBox>
      </DSBox>
    </DSBox>
  );
};

export default Dashboard;
